import { render } from "./TimeCardsForm.vue?vue&type=template&id=767b3576"
import script from "./TimeCardsForm.vue?vue&type=script&lang=ts"
export * from "./TimeCardsForm.vue?vue&type=script&lang=ts"
script.render = render

export default script